import { render, staticRenderFns } from "./CellRendererRegFormActions.vue?vue&type=template&id=b5b32d74&"
import script from "./CellRendererRegFormActions.vue?vue&type=script&lang=js&"
export * from "./CellRendererRegFormActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports